import { postApi } from 'api/fetchApi'
import { paths } from 'api/generated/phone_verification'

type Post = paths['/phone_verification/code/resend']['post']
type Response = Post['responses']['200']['schema']

export const phoneVerificationCodeResendApi = () => {
  return postApi<Response, Response>('/phone_verification/code/resend')
}
